module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step4_1-3b471524f2a2844b4a40c6267942bd81.png";